import { pass, fail, skip } from "../buildResult";
import { defineTest } from "../defineTest";
import { getEandMCode, isEandMEmpty } from "../helper/patientFields";

export default defineTest("e_and_m_present", "E&M", ({ patient }) => {
  if (!patient?.patient_id) return skip("No patient record");

  if (isEandMEmpty(patient.e_and_m)) {
    return fail(
      "E&M is missing",
      "patient.e_and_m is null, empty, or has no E&M code in postgres"
    );
  }

  const code = getEandMCode(patient.e_and_m);
  return pass(`E&M code present (${code})`);
});
